
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 228 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.2 23.5L15.9 34h6.5l-3.2-10.5zm7 22.9L25 42.6H13.3l-1.2 3.8H.9l12-32.6h12.4l12 32.6H26.2zM110.2 30.2c0-4.5-3.1-8.2-7.8-8.2-4.7 0-7.8 3.6-7.8 8.2 0 4.5 3.1 8.2 7.8 8.2 4.7-.1 7.8-3.7 7.8-8.2zm-25.7 0c0-10 7.8-16.9 17.8-16.9 10.1 0 17.8 6.8 17.8 16.9 0 10-7.8 16.9-17.8 16.9-10-.1-17.8-6.9-17.8-16.9zM123.7 46.4V13.8h24.8v8.6h-14.9v3.3h14.5v8.6h-14.5v12.1h-9.9zM159.7 46.4v-24h-8.8v-8.6h27.3v8.6h-8.7v24h-9.8zM39.1 14h10.8l5.8 7.7-5.2 7.3-11.4-15z","fill":"#fff"}}),_c('path',{attrs:{"d":"M74.3 31.2l12.4-17.4H76.3L63.7 31.6l5.5 6.9 5.8 7.7h10.7l-11.4-15z","fill":"#fff"}}),_c('path',{attrs:{"d":"M63.7 31.6L43.9 59.7h10.4l14.9-21.3-5.5-6.8zM55.7 21.7l5.4 7.1-12.5 17.7H38.1l17.6-24.8zM55.7 21.7L70.7.3h10.4l-20 28.5-5.4-7.1zM194.3 30.9v15.5h15.5V30.9h-15.5zm11 4.3h-5.1v3.2h4.6v1.1h-4.6v3.7h-1.3v-9.1h6.4v1.1zM211.6 30.9v15.5h15.5V30.9h-15.5zm10.9 12.3h-6.2v-9.1h1.3v8h4.9v1.1zM194.3 13.6v15.5h15.5V13.6h-15.5zm7.8 12.4c-1.4 0-2.8-.5-3.5-1.1l.5-1c.7.6 1.8 1.1 3 1.1 1.6 0 2.2-.6 2.2-1.4 0-2.2-5.5-.8-5.5-4.2 0-1.4 1.1-2.6 3.5-2.6 1.1 0 2.2.3 2.9.8l-.4 1c-.8-.5-1.7-.7-2.5-.7-1.5 0-2.2.6-2.2 1.4 0 2.2 5.5.8 5.5 4.2 0 1.3-1.1 2.5-3.5 2.5zM219.4 17.9c-2 0-3.4 1.5-3.4 3.5s1.4 3.5 3.4 3.5c1.9 0 3.4-1.5 3.4-3.5s-1.5-3.5-3.4-3.5z","fill":"#fff"}}),_c('path',{attrs:{"d":"M211.6 13.6v15.5h15.5V13.6h-15.5zm7.8 12.4c-2.7 0-4.6-2-4.6-4.7s2-4.7 4.6-4.7c2.7 0 4.6 2 4.6 4.7s-2 4.7-4.6 4.7z","fill":"#fff"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/img/AxoftSOFL.svg